import { OfferBox, OfferChip } from './OfferBox';

/**
 * §7.1: a paste over 1 500 characters asks before it becomes a chat turn. D148: `onChat` is null when the text is
 * longer than a turn may be (the server would refuse it), and then only "Bóc dữ liệu" is offered.
 */
export function PastePrompt({ busy, onExtract, onChat, onDismiss }: {
  busy: boolean; onExtract: () => void; onChat: (() => void) | null; onDismiss: () => void;
}) {
  return (
    <OfferBox label="Đoạn văn vừa dán" question="Bóc dữ liệu từ đoạn này?" dismissLabel="Bỏ qua đoạn dán"
      onDismiss={onDismiss}>
      <OfferChip onClick={onExtract} disabled={busy}>Bóc dữ liệu</OfferChip>
      {onChat !== null && <OfferChip onClick={onChat} disabled={busy}>Trả lời như chat</OfferChip>}
    </OfferBox>
  );
}
